import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgvmr3putu: FaireProductEntity = {
  token: "p_mgvmr3putu",
  type: "product",
  name: "Woodstock Crystal Meditation Chime™ - Silver",
  brandToken: "b_66wf2igxcf",
  brandName: "Woodstock Chimes",
  imageUrl:
    "https://cdn.faire.com/fastly/b905e43229347df42b576cdd71e39c48fa25ae5f461df4e87831a9881b77d750.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b0453278a4c486f3615a2b7c5a8471fd76dfc8fd33d70e2436a2398a693bb39.jpeg",
    "https://cdn.faire.com/fastly/96368ab2f73605682f20de8718037940bdaee1e9f67e45bf2c102b571ad199c3.jpeg",
    "https://cdn.faire.com/fastly/f69a5333cd0fbce0bbbd3e3293a25f0e3cb6a2d708a493ea3b5f2de8c0a48c6d.jpeg",
  ],
  priceDollars: 18.71,
  description:
    "This windchime's crystal accents and soothing sounds can be a focal point for meditation.\n\nThis wind chime can be used as an aid to meditation as a musical and visual mantra to help relax the mind and focus one's thoughts. Or enjoy it anytime for its soothing sounds and beautiful crystal accents. The practice of meditation has been an integral part of many religions for thousands of years. It has also been adopted, in modern times, as a way to improve physical and mental well-being. There are many different meditation techniques, but whether you are seeking spiritual growth or simply a little stress relief, it is important to create the right environment. Let our Crystal Meditation Chime help you create just the right ambience.",
  tags: [],
  msrpDollars: 38.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:01.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
